module.exports = __webpack_public_path__ + "img/010.a4e88803.png";